import React, { useState, useEffect, useMemo, useLayoutEffect } from 'react'
import styles from './OfferContractSelect.module.scss'
import { useSelectedTours } from '../../../../hooks'
import { useAuthStatus } from '../../../../utils'
import { Link } from 'react-router-dom'
import { IS_PERIOD_CONTRACT_SELECTION_DISABLED } from '../../../../config/featureFlags'

export const OfferContractSelect = ({
	onContractTypeChange,
	onPeriodTypeChange,
	isOfficialMode = false,
	initialContractType = null,
	initialPeriodTypes = [],
	isCaddieView = false,
	disabledPeriodHalves = [],
}) => {
	// 현재 연도
	const currentYear = 2026

	// 상반기 지났는지 체크 (6월 30일 지남 = 상반기 disabled)
	const isFirstHalfPeriodOptionDisabled = useMemo(() => {
		const today = new Date()
		const firstHalfEndDate = new Date(currentYear, 5, 30) // 2026년 6월 30일 (월은 0부터 시작)
		return today > firstHalfEndDate
	}, [currentYear])

	const [selectedContractType, setSelectedContractType] = useState(initialContractType)
	const [selectedPeriodTypes, setSelectedPeriodTypes] = useState(initialPeriodTypes)

	// 사용자 인증 정보와 선택된 투어 가져오기
	const [auth] = useAuthStatus()
	const { data: selectedToursData } = useSelectedTours(auth.user?.id)

	// 선택된 투어 목록 추출
	const selectedTours = selectedToursData?.tours || []
	console.log('selectedTours: ', selectedTours)

	// 초기값이 없을 때만 기본값 설정
	useEffect(() => {
		if (!initialContractType) {
			if (!isOfficialMode) {
				setSelectedContractType('preContract')
			} else {
				setSelectedContractType('short')
			}
			setSelectedPeriodTypes([])
		}
	}, [initialContractType, isOfficialMode])

	useLayoutEffect(() => {
		if (!isOfficialMode || !IS_PERIOD_CONTRACT_SELECTION_DISABLED) return
		if (selectedContractType !== 'period') return
		setSelectedContractType('short')
		setSelectedPeriodTypes([])
	}, [isOfficialMode, selectedContractType])

	// 계약 타입 변경 시 부모 컴포넌트에 알림
	useEffect(() => {
		if (onContractTypeChange) {
			onContractTypeChange(selectedContractType)
		}
	}, [selectedContractType, onContractTypeChange])

	// 기간 타입 변경 시 부모 컴포넌트에 알림
	useEffect(() => {
		if (onPeriodTypeChange) {
			onPeriodTypeChange(selectedPeriodTypes)
		}
	}, [selectedPeriodTypes, onPeriodTypeChange])

	const handleContractTypeSelect = (type) => {
		if (type === 'period' && isOfficialMode && IS_PERIOD_CONTRACT_SELECTION_DISABLED) {
			return
		}
		setSelectedContractType(type)
		// period가 아니면 period 선택 초기화
		if (type !== 'period') {
			setSelectedPeriodTypes([])
		}
	}

	const isFirstHalfDisabledByPartner = disabledPeriodHalves.includes('first_half')
	const isSecondHalfDisabledByPartner = disabledPeriodHalves.includes('second_half')

	const handlePeriodTypeSelect = (type) => {
		if (
			type === 'first_half' &&
			(isFirstHalfPeriodOptionDisabled || isFirstHalfDisabledByPartner)
		) {
			return
		}
		if (type === 'second_half' && isSecondHalfDisabledByPartner) {
			return
		}

		setSelectedPeriodTypes((prevTypes) => {
			if (prevTypes.includes(type)) {
				return prevTypes.filter((t) => t !== type)
			} else {
				return [...prevTypes, type]
			}
		})
	}

	return (
		<div className={styles.suggestContractSelectContainer}>
			{isOfficialMode &&
				!isCaddieView &&
				(!selectedToursData || !selectedToursData.tours || selectedTours.length === 0) && (
					<div className={styles.warningMessageContainer}>
						<div className={styles.warningMessage}>
							<div>
								<svg
									width="14"
									height="14"
									viewBox="0 0 14 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7ZM7 4.5C7.27614 4.5 7.5 4.72386 7.5 5V7.5C7.5 7.77614 7.27614 8 7 8C6.72386 8 6.5 7.77614 6.5 7.5V5C6.5 4.72386 6.72386 4.5 7 4.5ZM7 10C7.27614 10 7.5 9.77614 7.5 9.5C7.5 9.22386 7.27614 9 7 9C6.72386 9 6.5 9.22386 6.5 9.5C6.5 9.77614 6.72386 10 7 10Z"
										fill="#FF5D5D"
									/>
								</svg>
								출전 대회 미설정 상태에요. 대회별 계약을 원하시면 출전 대회를
								설정해주세요.
							</div>
						</div>

						<Link to="/myinfo/upcomingtournaments" className={styles.selectionButton}>
							설정하기
						</Link>
					</div>
				)}

			<div className={styles.contractTypeMessage}>계약 유형</div>
			{!isOfficialMode && (
				<div
					className={`${styles.preContract} ${selectedContractType === 'preContract' ? styles.contractTypeActive : ''}`}
					onClick={() => handleContractTypeSelect('preContract')}>
					<div>사전계약</div>
					<div>2026년 시즌 준비</div>
				</div>
			)}
			<div className={styles.contractType}>
				<div
					className={`${styles.short} ${selectedContractType === 'short' ? styles.contractTypeActive : ''} ${!isOfficialMode ? styles.disabled : ''}`}
					onClick={() => (isOfficialMode ? handleContractTypeSelect('short') : {})}>
					<div>단기계약</div>
					<div>1개 대회</div>
				</div>
				<div
					className={`${styles.long} ${selectedContractType === 'long' ? styles.contractTypeActive : ''} ${!isOfficialMode ? styles.disabled : ''}`}
					onClick={() => (isOfficialMode ? handleContractTypeSelect('long') : {})}>
					<div>장기계약</div>
					<div>2개 이상 대회</div>
				</div>
				<div
					className={`${styles.period} ${selectedContractType === 'period' ? styles.contractTypeActive : ''} ${!isOfficialMode || IS_PERIOD_CONTRACT_SELECTION_DISABLED ? styles.disabled : ''} ${IS_PERIOD_CONTRACT_SELECTION_DISABLED ? styles.periodSoon : ''}`}
					onClick={() =>
						isOfficialMode && !IS_PERIOD_CONTRACT_SELECTION_DISABLED
							? handleContractTypeSelect('period')
							: undefined
					}>
					<div>기간계약</div>
					<div>상반기/하반기</div>
					{IS_PERIOD_CONTRACT_SELECTION_DISABLED ? (
						<span className={styles.soonChip}>오픈예정</span>
					) : null}
				</div>
			</div>
			{selectedContractType === 'period' && (
				<div className={styles.periodContractType}>
					<div className={styles.periodTypeMessage}>기간계약 세부</div>
					<div className={styles.targetPeriod}>
						<div
							className={`${styles.firstHalf} ${selectedPeriodTypes.includes('first_half') ? styles.periodTypeActive : ''} ${isFirstHalfPeriodOptionDisabled || isFirstHalfDisabledByPartner ? styles.disabled : ''}`}
							onClick={() => handlePeriodTypeSelect('first_half')}>
							<svg
								className={styles.firstHalfPeriodCheckImage}
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M0.6875 8C0.6875 3.96142 3.96142 0.6875 8 0.6875C12.0386 0.6875 15.3125 3.96142 15.3125 8C15.3125 12.0386 12.0386 15.3125 8 15.3125C3.96142 15.3125 0.6875 12.0386 0.6875 8ZM10.7077 6.63945C10.8883 6.38665 10.8297 6.03534 10.5769 5.85477C10.3242 5.67421 9.97284 5.73276 9.79227 5.98555L7.36572 9.38273L6.14775 8.16475C5.92808 7.94508 5.57192 7.94508 5.35225 8.16475C5.13258 8.38442 5.13258 8.74058 5.35225 8.96025L7.03975 10.6477C7.15667 10.7647 7.31911 10.8242 7.4839 10.8106C7.64868 10.7969 7.79912 10.7115 7.89523 10.5769L10.7077 6.63945Z"
									fill="currentColor"
								/>
							</svg>
							{currentYear} 상반기
						</div>
						<div
							className={`${styles.lastHalf} ${selectedPeriodTypes.includes('second_half') ? styles.periodTypeActive : ''} ${isSecondHalfDisabledByPartner ? styles.disabled : ''}`}
							onClick={() => handlePeriodTypeSelect('second_half')}>
							<svg
								className={styles.lastHalfPeriodCheckImage}
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M0.6875 8C0.6875 3.96142 3.96142 0.6875 8 0.6875C12.0386 0.6875 15.3125 3.96142 15.3125 8C15.3125 12.0386 12.0386 15.3125 8 15.3125C3.96142 15.3125 0.6875 12.0386 0.6875 8ZM10.7077 6.63945C10.8883 6.38665 10.8297 6.03534 10.5769 5.85477C10.3242 5.67421 9.97284 5.73276 9.79227 5.98555L7.36572 9.38273L6.14775 8.16475C5.92808 7.94508 5.57192 7.94508 5.35225 8.16475C5.13258 8.38442 5.13258 8.74058 5.35225 8.96025L7.03975 10.6477C7.15667 10.7647 7.31911 10.8242 7.4839 10.8106C7.64868 10.7969 7.79912 10.7115 7.89523 10.5769L10.7077 6.63945Z"
									fill="currentColor"
								/>
							</svg>
							{currentYear} 하반기
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
